import Head from 'next/head';
import { useSelector } from 'react-redux';
import { NextSeo } from 'next-seo';
import ProdigyContainer from '@cont/Prodigy/ProdigyContainer';
import { fetchTestSeriesData } from '@actions/quizzes';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const TestSeries = () => {
  const data = useSelector(({ quizzes }) => quizzes.testSeries?.aspire || null);
  const { metaData = {} } = data;
  const { title, description, ogImage, twitterOgImage } = metaData;
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          title,
          description,
          images: [
            {
              url: ogImage
            }
          ]
        }}
        twitter={{
          images: [{ url: twitterOgImage }]
        }}
      />
      <Head>
        <title>{metaData.title}</title>
      </Head>
      <ProdigyContainer data={data} />
    </>
  );
};

TestSeries.pageInfo = {
  name: 'Unacademy Aspire',
  isMWebSupported: true,
  layoutOptions: {
    hideSearch: true,
    hideGoalSelector: true,
    hideLearnerMinutes: true,
    hideNudges: true,
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

TestSeries.getInitialProps = setupInitialProps(async ({ store }) => {
  if (!store.getState().quizzes.testSeries?.aspire) {
    await store.dispatch(fetchTestSeriesData('aspire'));
  }
}, TestSeries.pageInfo);

export default TestSeries;
TestSeries.Layout = Layout;
TestSeries.Wrapper = PageReduxProvider;
